import { Injectable } from "@angular/core";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { ConstantService } from "app/Shared/Services/constant-service";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { UrlsService } from "app/Shared/Services/urls.service";
import { UserService } from "app/Shared/Services/user.service";
import { MessageService } from "primeng/api";
import { map } from 'rxjs/operators';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';

@Injectable()
export class AuditTrailService {
  dataArray: any = [];

  constructor(
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private userService: UserService,
    private messageService: MessageService,
    public constantService: ConstantService) {
  }

  getData(payload:any) {
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.Audit_Record_Details,), payload)
    .pipe(map((response: Response) => {
        return response;
      }))
  }


  exportToCSV(type:any, firmROEID:any, cols:any, pagename = this.constantService.getApplicationName(), filterData: any = []) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    const filename = 'RSMS_Audit_Trail_Tree_' + type + '_' + firmROEID + '_' + this.userService.getyyyyMMddDateFormate(new Date());
    this.messageService.add({ severity: 'info', summary: 'File', detail: 'File Download Started' });
    if (this.dataArray.length > 0) {
      const mkConfig :any = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: filename,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        filename: filename
      };
      const csv = generateCsv(mkConfig)(this.constantService.getExportData(this.dataArray, cols));
      const blob = asBlob(mkConfig)(csv);
      saveAs(blob, filename);
      this.messageService.add({
        severity: 'success', summary: 'File', detail: 'File Download Successfully' + filename
      });
      this.userService.logUserActivity('Export CSV' + ((typeof pagename!=='undefined' && pagename!=='Audit Trails') ? ' - Audit Trails' : ''), pagename, {
        'Text1': 'File Download Successfully | ' + (this.dataArray.length > 0 ? this.dataArray.length : 0) + ' records downloaded with file name: ' + mkConfig.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
      this.userService.logUserActivity('Export CSV' + ((typeof pagename!=='undefined' && pagename!=='Audit Trails') ? ' - Audit Trails' : ''), pagename, {
        'Text1': 'No data found',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }
  }

}